// extracted by mini-css-extract-plugin
export var dateLabel = "_3k-0";
export var dateLabelError = "_3k-1";
export var fullWidth = "_3k-2";
export var smaller = "_3k-3";